/* eslint-disable no-useless-escape */
let DATA_CONFIG = {}

export function getConfig () {
  return new Promise((resolve, reject) => {
    fetch('/config.json', { cache: 'no-store' }).then(async res => {
      const data = await res.json()
      DATA_CONFIG = data
      resolve(data)
    }).catch(_err => reject(_err))
  })
}

const ENUM_ENV = {
  SOCKET_URL: 'http://dsocket.cd.local',
  BASE_API: 'http://dapis.cd.local/msqueue',
  BASE_URL_SCAN: 'https://caredr.org',
  PARAMS_CODE_BOOKING: '/dappt',
  PARAMS_CODE_BOOKING_SERVICE: '/dservcappt',
  PARAMS_GENERATED: '/dq',
  PARAMS_PRINTER: '/dprinter',
  QUERY_PARAMS_GENERATED: '{generatedId}%26\$fallback_url%3Dhttps%3A%2F%2Fddigitalq%252Ecditdev%252Exyz%2Fqueue%2F{generatedId}',
  ADMIN_PAGE: 'SUPER-ADMIN-PAGE',
  LABEL_HOME_KIOSK_CHECKIN: 'Silakan scan QR Code Anda untuk mulai mengantri',
  URL_PRINTER: '',
  SECRET_PRINTER: '',
  REPORT_URL: 'https://hooks.slack.com/services/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',
  FOOTER_TICKET: '[{\"type\":\"text\",\"value\":\"Tiket ini digunakan selama kunjungan Anda di\"},{\"type\":\"text\",\"value\": \"Rumah Sakit, mohon dijaga dengan baik\"},{\"type\":\"enter\",\"value\":\"\"},{\"type\":\"text\",\"value\":\"Silakan scan QR Code di atas untuk menerima\"},{\"type\":\"text\",\"value\":\"tiket antrian versi digital\"},{\"type\":\"enter\",\"value\":\"\"},{\"type\":\"text\",\"value\":\"Antrian dapat di skip jika nomor yang dipanggil\"},{\"type\":\"text\",\"value\":\"tidak ada ditempat\"}]'
}

export const getDataConfig = () => {
  const VUE_APP_SOCKET_URL = DATA_CONFIG.VUE_APP_SOCKET_URL || ENUM_ENV.SOCKET_URL
  const VUE_APP_API_URL = DATA_CONFIG.VUE_APP_API_URL || ENUM_ENV.BASE_API
  const VUE_APP_URL_SCAN = DATA_CONFIG.VUE_APP_URL_SCAN || ENUM_ENV.BASE_URL_SCAN
  const VUE_APP_PARAMS_CODE_BOOKING = DATA_CONFIG.VUE_APP_PARAMS_CODE_BOOKING || ENUM_ENV.PARAMS_CODE_BOOKING
  const VUE_APP_PARAMS_CODE_BOOKING_SERVICE = DATA_CONFIG.VUE_APP_PARAMS_CODE_BOOKING_SERVICE || ENUM_ENV.PARAMS_CODE_BOOKING_SERVICE
  const VUE_APP_PARAMS_GENERATED = DATA_CONFIG.VUE_APP_PARAMS_GENERATED || ENUM_ENV.PARAMS_GENERATED
  const VUE_APP_PARAMS_PRINTER = DATA_CONFIG.VUE_APP_PARAMS_PRINTER || ENUM_ENV.PARAMS_PRINTER
  const VUE_APP_QUERY_PARAMS_GENERATED = DATA_CONFIG.VUE_APP_QUERY_PARAMS_GENERATED || ENUM_ENV.QUERY_PARAMS_GENERATED
  const VUE_APP_ADMIN_PAGE = DATA_CONFIG.VUE_APP_ADMIN_PAGE || ENUM_ENV.ADMIN_PAGE
  const VUE_APP_LABEL_HOME_KIOSK_CHECKIN = DATA_CONFIG.VUE_APP_LABEL_HOME_KIOSK_CHECKIN || ENUM_ENV.LABEL_HOME_KIOSK_CHECKIN
  const VUE_APP_URL_PRINTER = DATA_CONFIG.VUE_APP_URL_PRINTER ?? ENUM_ENV.URL_PRINTER
  const VUE_APP_SECRET_PRINTER = DATA_CONFIG.VUE_APP_SECRET_PRINTER ?? ENUM_ENV.SECRET_PRINTER
  const VUE_APP_REPORT_ERROR = DATA_CONFIG.VUE_APP_REPORT_ERROR ?? ENUM_ENV.REPORT_URL
  const dataFooter = DATA_CONFIG.VUE_APP_FOOTER_PRINT_TICKET ?? ENUM_ENV.FOOTER_TICKET
  let VUE_APP_FOOTER_PRINT_TICKET = dataFooter
  try {
    VUE_APP_FOOTER_PRINT_TICKET = JSON.parse(dataFooter)
  } catch {
    VUE_APP_FOOTER_PRINT_TICKET = JSON.parse(ENUM_ENV.FOOTER_TICKET)
  }
  return {
    VUE_APP_SOCKET_URL,
    VUE_APP_API_URL,
    VUE_APP_URL_SCAN,
    VUE_APP_PARAMS_CODE_BOOKING,
    VUE_APP_PARAMS_CODE_BOOKING_SERVICE,
    VUE_APP_PARAMS_GENERATED,
    VUE_APP_PARAMS_PRINTER,
    VUE_APP_QUERY_PARAMS_GENERATED,
    VUE_APP_ADMIN_PAGE,
    VUE_APP_LABEL_HOME_KIOSK_CHECKIN,
    VUE_APP_FOOTER_PRINT_TICKET,
    VUE_APP_URL_PRINTER,
    VUE_APP_SECRET_PRINTER,
    VUE_APP_REPORT_ERROR
  }
}
